import type { AtomReference } from '@stratumn/studio-shared';

export type DatabaseVariables = Map<string, AtomReference>;

export const useDatabaseVariables = (): DatabaseVariables => {
  // TODO: rework
  return new Map<string, AtomReference>();
};
